import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Tabs, Tab } from '@hz-design-system/web-ui';
import Classes from './LoginTabs.module.scss';

type TLoginTabsProps = {
  isLoginActive?: boolean;
  isCreateAccountActive?: boolean;
};

const LoginTabs = ({ isLoginActive = false, isCreateAccountActive = false }: TLoginTabsProps) => {
  const { t } = useI18nContext();

  const goToLogin = () => {
    window.location.href = '/identity/v2/login';
  };

  const goToRegistration = () => {
    window.location.href = '/identity/v2/create-account';
  };

  return (
    <Tabs className={Classes.root}>
      <Tab label={t('pages.login.login_tab')} isActive={isLoginActive} onClick={goToLogin} />
      <Tab
        label={t('pages.create_account.create_account_tab')}
        isActive={isCreateAccountActive}
        onClick={goToRegistration}
      />
    </Tabs>
  );
};

export default LoginTabs;
